module.exports = __webpack_public_path__ + "img/img-12.a18c0fff.webp";